import i18n from 'i18n';
import PropTypes from 'prop-types';
import React from 'react';
const PAGE_BUTTON_STYLE = {
  minWidth: 44,
  display: 'inline-flex',
  justifyContent: 'center',
  alignItems: 'center',
};
const ACTIVE_BUTTON_STYLE = {
  backgroundColor: '#be1622',
  color: 'white',
};

const Pagination = ({ activePage, numberOfPages, goToPage }) => (
  <ul className="pagination flex-wrap justify-content-center mt-3">
    <li className={`page-item  ${activePage === 0 && 'disabled'}`}>
      <button
        type="button"
        className="page-link"
        style={PAGE_BUTTON_STYLE}
        onClick={() => goToPage(activePage - 1)}
      >
        {i18n.t('app:previous')}
      </button>
    </li>
    {[...new Array(numberOfPages).keys()]
      .filter(
        (pageIndex) =>
          (activePage < pageIndex ? pageIndex - activePage < 5 : activePage - pageIndex <= 5) ||
          (pageIndex < 10 && activePage <= 5),
      )
      .map((pageIndex) => (
        <li key={pageIndex} className={`page-item  ${pageIndex === activePage && 'active'}`}>
          <button
            type="button"
            className="page-link"
            style={{
              ...PAGE_BUTTON_STYLE,
              ...(pageIndex === activePage ? ACTIVE_BUTTON_STYLE : {}),
            }}
            onClick={() => goToPage(pageIndex)}
          >
            {pageIndex + 1}
          </button>
        </li>
      ))}
    <li className={`page-item  ${activePage + 1 === numberOfPages && 'disabled'}`}>
      <button
        type="button"
        className="page-link"
        style={PAGE_BUTTON_STYLE}
        onClick={() => goToPage(activePage + 1)}
      >
        {i18n.t('app:next')}
      </button>
    </li>
  </ul>
);

Pagination.propTypes = {
  activePage: PropTypes.number,
  numberOfPages: PropTypes.number,
  goToPage: PropTypes.func.isRequired,
};

export default Pagination;
